<ng-container *transloco="let t;">
    <form [formGroup]="filterForm" (ngSubmit)="applyFilter()" #form="ngForm">
        <div class="form-group">
            <div class="row">
                <div class="col-xl-12 col-md-12 col-12 mb-0">
                    <div class="form-group mb-0 w-100">
                        <div class="form-control pt-0 pb-0">
                            <ng-select [multiple]="false"
                                       [closeOnSelect]="true"
                                       [items]="ddlItems"
                                       bindValue="value"
                                       bindLabel="name"
                                       formControlName="value"
                                       [placeholder]="t('Advanced filter operators select placeholder (Advanced filters) - Select')">
                            </ng-select>
                            <div *ngIf="form.submitted && filterForm.invalid" class="invalid-feedback d-block">
                                <div *ngIf="filterForm.controls['value'].hasError('required')">{{ t('Advanced filter required field validation (Advanced filters) - This field is required') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12 col-md-12 col-12 mb-0">
                    <label>{{ t('Advanced filter operator label (Advanced filters) - Operator') }}</label>
                    <app-operator-selector formControlName="operator"
                                           class="form-control"
                                           [items]="availableOperators"></app-operator-selector>
                    <div *ngIf="form.submitted && filterForm.invalid" class="invalid-feedback d-block">
                        <div *ngIf="filterForm.controls['operator'].hasError('required')">{{ t('Advanced filter required field validation (Advanced filters) - This field is required') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <button type="submit"
                class="btn btn btn-primary btn-sm w-100">{{ t('Apply filter button name (Advanced filters) - Done') }}
        </button>
    </form>
</ng-container>